import StaffPerformanceHTMLPreviewBaseSection from './StaffPerformanceHTMLPreviewBaseSection'
import {ReportGroupingLevel} from '../../../constants'

export default function StaffPerformanceHTMLPreviewGroupingSection() {}

StaffPerformanceHTMLPreviewGroupingSection.prototype = new StaffPerformanceHTMLPreviewBaseSection();

StaffPerformanceHTMLPreviewGroupingSection.prototype.init = function( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, longView, columnsStrategy )
{
    StaffPerformanceHTMLPreviewBaseSection.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.longView = longView;
    return this;
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.addRows = function( tBody )
{
    this.addRow( tBody, this.makeGroupingTotalRow() );

    let maxGroupingRows = this.longView ? 8 : 5
    let groupingRows = 0
    while( true )
    {
        this.addRow( tBody, this.makeGroupingRow( "firstGrouping", "firstLevel", this.firstGroupingLevel ) );
        groupingRows++;
        if( groupingRows >= maxGroupingRows )
            break;

        if( this.secondGroupingLevel !== ReportGroupingLevel.NONE )
        {
            this.addRow( tBody, this.makeGroupingRow( "secondGrouping", "secondLevel", this.secondGroupingLevel ) );
            groupingRows++;
            if( groupingRows >= maxGroupingRows )
                break;
        }

        if( this.thirdGroupingLevel !== ReportGroupingLevel.NONE )
        {
            var tgRow = this.makeThirdGroupingRow();
            this.addRow( tBody, tgRow );
            groupingRows++;
            if( groupingRows >= maxGroupingRows )
                break;
            if( this.secondGroupingLevel !== ReportGroupingLevel.NONE &&
                groupingRows < maxGroupingRows &&
                ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.thirdGroupingLevel, [this.firstGroupingLevel, this.secondGroupingLevel]) )
            {
                tgRow = this.makeThirdGroupingRow();
                this.addRow( tBody, tgRow );
                groupingRows++;
                if( groupingRows >= maxGroupingRows )
                    break;
            }
        }
    }
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.makeGroupingTotalRow = function ()
{
    return this.createRowWithMainAndDataCells("groupingTotal", this.message("report.staffoutput.total_working_time"), "groupingTotalCell firstChild" );
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.makeThirdGroupingRow = function ()
{
    let cellClassName = this.secondGroupingLevel === ReportGroupingLevel.NONE ? "secondLevel" : "thirdLevel"
    return this.makeGroupingRow( "thirdGrouping", cellClassName, this.thirdGroupingLevel );
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.makeGroupingRow = function ( rowClassName, cellClassName, groupingLevel )
{
    return this.createRowWithMainAndDataCells(rowClassName, ReportPreviewUtils.getLevelPreviewName(groupingLevel), cellClassName + " firstChild");
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/staffperformance/StaffPerformanceHTMLPreviewGroupingSection.js